//TODO: Document controls
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DynamicContentOutletModule } from '@Work/Accounts/proprietary/dynamic-content-outlet/dynamic-content-outlet.module';
import { PipeModule } from '@Shared/Pipes/proprietary/pipe.module';
import { ControlModule } from '../control.module';
import { FormControlModule } from '../form-controls/form-control.module';
import { UXDesignerLabelEditPanelComponent } from './ux-designer-label-edit-panel/ux-designer-label-edit-panel.component';
import { UxDesignerPropertiesComponent } from './ux-designer-properties/ux-designer-properties.component';
import { UXDesignerRuleEditPanelComponent } from './ux-designer-rule-edit-panel/ux-designer-rule-edit-panel.component';

@NgModule({
    imports: [
        CommonModule,
        NgbTooltipModule,
        ControlModule,
        PipeModule,
        FormControlModule,
        FormsModule,
        DragDropModule,
        DynamicContentOutletModule
    ],
    declarations: [UxDesignerPropertiesComponent, UXDesignerRuleEditPanelComponent, UXDesignerLabelEditPanelComponent],
    exports: [UxDesignerPropertiesComponent, DragDropModule, DynamicContentOutletModule]
})
export class UxDesignerModule { }
